import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { getLogger } from '../../util/logger';
import bureaucrat from '../../util/Bureaucrat';
import { getEncodedUpload } from '../../util/FileReader';
import { parseErrorMessage } from '../util/dataHelpers';

const logger = getLogger('useHybridOptionsFormHandler');

export const useHybridOptionsFormHandlers = (onComplete, onCancel, formRef) => {
  const history = useHistory();
  const [errorMsg, setErrorMsg] = useState('');
  const [showEdge, setShowEdge] = useState(false);
  const [edgeDomain, setEdgeDomain] = useState('');
  const [showProgress, setShowProgress] = useState(false);

  const handleCancel = (event) => {
    event.preventDefault();
    onCancel();
  };

  const handleSubmit = async (values, actions) => {
    scroll.scrollToTop();
    setShowProgress(true);

    const redactedValues = { ...values };
    redactedValues.certificateKey = '*******';
    logger.debug(redactedValues);
    try {
      await bureaucrat.updateHybridOptions(
        getEncodedUpload(),
        values.certificateKey,
        values.skypeUser,
        values.skypeDomain,
        values.skypeAddress,
        values.skypePort,
        values.cloudServiceEmail,
      );
      onComplete();
    } catch (error) {
      actions.setSubmitting(false);
      parseErrorMessage(error, setErrorMsg, history);
    } finally {
      setShowProgress(false);
    }
  };

  const handleEdgeClick = () => {
    setShowEdge(true);
    const newDomain = formRef.current.values.skypeDomain;
    setEdgeDomain(newDomain);
  };

  return {
    handleSubmit,
    handleCancel,
    handleEdgeClick,
    errorMsg,
    showEdge,
    setShowEdge,
    edgeDomain,
    showProgress,
  };
};
